import { Tab, ThemeProvider } from "@material-ui/core";
import { useIO } from "@type-r/react";
import { globalStore } from "api";
import { Loading, NavigationTabs, isEmbeddedApp, theme, useLinkedLocation } from "lqx-react";
import * as React from "react";
import { BankTransactionsPage } from "./bank-transactions";
import { InvoicesPage } from "./invoices";
import { MatchingPage } from "./matching";
import { Metrics } from './metrics';
import { RemittancePage } from "./remittance";
import { appConfig } from "../digitization/api/appConfig";
import { Can } from "src/app/services/can";
import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";

export const InmatchPage = (props) => {
    appConfig.loadFrom(props.appConfig);
    const $category = useLinkedLocation(2, "matching"),
        category = $category.value;

    const isNotEmbedded = !isEmbeddedApp();

    const isReady = useIO(async () => {
        if (isNotEmbedded) {
            localStorage.setItem('platformCode', 'LQX');
        }

        await globalStore.fetchAfterLogin(true);

    });
    
    const canBookReverse = Can(UserEntitlementCatalogs.BankEntryView) ||
    Can(UserEntitlementCatalogs.BankEntryWrite) ||
    Can(UserEntitlementCatalogs.BankEntryConfirm);
    return isReady ?

        <div style={{ height: 'calc(100% - 33px)' }}>
            {
                (Can(UserEntitlementCatalogs.BankEntryView) ||
                Can(UserEntitlementCatalogs.BankEntryWrite) ||
                Can(UserEntitlementCatalogs.BankEntryConfirm) ||
                Can(UserEntitlementCatalogs.ReverseInmatchPayment))
             ?
            <>
                <ThemeProvider theme={theme}>
                    <NavigationTabs $value={$category}>
                        <Tab label="Matching" value="matching" />
                        <Tab label="Bank Transactions" value="bank-transactions" disabled={!canBookReverse} />
                        <Tab label="Invoices" value="invoices" disabled={!canBookReverse} />
                        <Tab label="Remittance Advices" value="remittance-advices" disabled={!canBookReverse} />
                    </NavigationTabs>
                </ThemeProvider>
                {category === "matching" ? (
                    <MatchingPage />
                ) : category === "bank-transactions" ? (
                    <BankTransactionsPage />
                ) : category === "invoices" ? (
                    <InvoicesPage />
                ) : category === "remittance-advices" ? (
                    <RemittancePage navigateToOnSave='/remittance-advices/unmatched' showSuccessSnackBar />
                ) : isNotEmbedded && category === "metrics" ? (
                    <Metrics />
                ) : (
                    <h1>Wrong path</h1>
                )}
            </> : undefined
            }
        </div>
        :
        <Loading />
};

